// import React from "react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import {
//   ShieldCheck,
//   Server,
//   Network,
//   Cpu,
//   Database,
//   Layers,
//   Cloud,
//   Laptop,
//   Box,
//   Globe,
//   FileText,
//   ArrowRight
// } from "lucide-react";

// export function renderagentsetup() {
//   return <AgentSetupLanding />;
// }

// // ─── gradient configs per card ───────────────────────────────────────────────
// const CARD_GRADIENTS = [
//   "from-sky-400 to-indigo-500",
//   "from-emerald-400 to-cyan-500",
//   "from-orange-400 to-red-500",
//   "from-yellow-400 to-green-500",
//   "from-indigo-400 to-purple-500",
//   "from-cyan-400 to-indigo-500",
//   "from-emerald-400 to-teal-500",
//   "from-amber-400 to-red-500",
//   "from-sky-400 to-purple-500",
//   "from-rose-400 to-orange-500",
//   "from-purple-400 to-pink-500",
//   "from-blue-700 to-sky-400",
// ];

// function pickGradient(index) {
//   return CARD_GRADIENTS[index % CARD_GRADIENTS.length];
// }

// const LOGO_SOURCES = {
//   Linux: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/linux.svg",
//   Windows: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/windows.svg",
//   Java: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/java.svg",
//   Python: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/python.svg",
//   ".Net": "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/dotnet.svg",
//   PHP: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/php.svg",
//   "Node.js": "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/nodedotjs.svg",
//   MySQL: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/mysql.svg",
//   MsSQL: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/microsoftsqlserver.svg",
//   Oracle: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/oracle.svg",
//   ActiveMQ: "https://activemq.apache.org/assets/img/activemq_logo_icon.svg",
//   Kafka: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/apachekafka.svg",
//   Azure: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/microsoftazure.svg",
//   AWS: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/amazonaws.svg",
// };

// function LogoMark({ title, className = "w-[18px] h-[18px]" }) {
//   const src = LOGO_SOURCES[title];

//   if (!src) return null;

//   return (
//     <img
//       src={src}
//       alt={`${title} logo`}
//       className={`${className} object-contain`}
//       style={{ filter: "brightness(0) invert(1)" }}
//       draggable="false"
//       loading="eager"
//       referrerPolicy="no-referrer"
//     />
//   );
// }

// // ─── Tile card (the individual guide card with banner + avatar) ───────────────
// function Tile({ title, route, subtitle, gradientIndex = 0 }) {
//   const navigate = useNavigate();
//   const gradient = pickGradient(gradientIndex);

//   return (
//     <motion.button
//       onClick={() => navigate(route)}
//       whileHover={{ y: -4 }}
//       whileTap={{ scale: 0.97 }}
//       className="group w-full text-left bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 rounded-[14px] overflow-visible relative cursor-pointer flex flex-col justify-between"
//       style={{ isolation: "isolate" }}
//     >
//       <div>
//         {/* Banner */}
//         <div className="card-banner-wrap relative pb-5">
//           <div className={`h-[52px] rounded-t-[14px] overflow-hidden relative bg-gradient-to-r ${gradient}`}>
//             <svg className="absolute bottom-0 left-0 w-full h-6" viewBox="0 0 200 24" preserveAspectRatio="none">
//               <path d="M0 12 Q50 0 100 12 Q150 24 200 12 L200 24 L0 24Z" fill="white" fillOpacity="0.13" />
//             </svg>
//           </div>

//           {/* Logo Avatar */}
//           <div
//             className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-[38px] h-[38px] rounded-[11px] flex items-center justify-center text-xs font-bold text-white border-[3px] border-white dark:border-[#0e141b] shadow-[0_2px_10px_rgba(0,0,0,0.2)] z-10 bg-gradient-to-br ${gradient}`}
//           >
//             <LogoMark title={title} className="w-[18px] h-[18px]" />
//           </div>
//         </div>

//         {/* Body */}
//         <div className="pt-2 pb-2.5 px-3 text-center">
//           <div className="text-[12px] font-medium text-slate-900 dark:text-white">
//             {title}
//           </div>
//           <div className="text-[10px] text-slate-400 dark:text-slate-500 mt-px">
//             {subtitle}
//           </div>
//         </div>
//       </div>

//       {/* Footer */}
//       <div className="flex items-center gap-1.5 px-3 py-1.5 border-t border-slate-200/70 dark:border-white/10 text-[10px] text-slate-400 dark:text-slate-500">
//         <FileText className="w-3 h-3" />
//         <span>Guide</span>
//         <div className="ml-auto flex items-center bg-slate-100 dark:bg-white/5 border border-slate-200/70 dark:border-white/10 rounded-full px-2 py-0.5 font-medium group-hover:bg-slate-200 dark:group-hover:bg-white/10 transition-colors">
//           <ArrowRight className="w-2.5 h-2.5" />
//         </div>
//       </div>
//     </motion.button>
//   );
// }

// // ─── GroupCard (Azure / AWS nested tiles) ────────────────────────────────────
// function GroupCard({ title, count, bannerBg, icon: Icon, logoTitle, children }) {
//   return (
//     <div className="rounded-[14px] bg-slate-50 dark:bg-white/5 border border-slate-200/70 dark:border-white/10 overflow-hidden">
//       {/* provider banner */}
//       <div className={`h-9 flex items-center gap-2 px-3.5 border-b border-slate-200/70 dark:border-white/10 bg-gradient-to-r ${bannerBg}`}>
//         {logoTitle ? (
//           <LogoMark title={logoTitle} className="w-4 h-4" />
//         ) : (
//           <Icon className="w-4 h-4 text-white" />
//         )}
//         <span className="text-[12px] font-semibold text-white">
//           {title}
//         </span>
//         <span className="ml-auto text-[10px] text-white/70">
//           {count} guide{count !== 1 ? "s" : ""}
//         </span>
//       </div>
//       {/* provider body */}
//       <div className="p-2 grid gap-1.5">{children}</div>
//     </div>
//   );
// }

// // ─── GroupTile (compact list row inside GroupCard) ───────────────────────────
// function GroupTile({ title, route, subtitle, icon: Icon, iconBg, iconColor }) {
//   const navigate = useNavigate();
//   return (
//     <motion.button
//       onClick={() => navigate(route)}
//       whileHover={{ x: 2 }}
//       whileTap={{ scale: 0.98 }}
//       className="group flex items-center gap-2.5 w-full text-left p-2.5 rounded-[10px] bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 transition-all"
//     >
//       <div
//         className="w-[30px] h-[30px] rounded-[8px] flex items-center justify-center text-sm flex-shrink-0"
//         style={{ backgroundColor: iconBg, color: iconColor }}
//       >
//         <Icon className="w-[15px] h-[15px]" />
//       </div>
//       <div>
//         <div className="text-[12px] font-medium text-slate-900 dark:text-white">
//           {title}
//         </div>
//         <div className="text-[10px] text-slate-400 dark:text-slate-500 mt-px">
//           {subtitle}
//         </div>
//       </div>
//       <ArrowRight className="w-3.5 h-3.5 text-slate-400 dark:text-slate-500 ml-auto transition-transform group-hover:translate-x-0.5" />
//     </motion.button>
//   );
// }

// // ─── SectionCard (the outer section wrapper) ─────────────────────────────────
// function SectionCard({ title, description, icon: Icon, headerBg, meta, isCloudGrid, children }) {
//   return (
//     <div className="mb-5 rounded-[20px] bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 overflow-hidden">
//       {/* section header */}
//       <div className="flex items-center gap-3 px-[1.1rem] py-[0.85rem] bg-slate-50 dark:bg-white/[0.02] border-b border-slate-200/70 dark:border-white/10">
//         <div
//           className="w-9 h-9 rounded-[10px] flex items-center justify-center text-lg flex-shrink-0 text-white"
//           style={{ background: headerBg }}
//         >
//           <Icon className="w-[18px] h-[18px]" />
//         </div>
//         <div>
//           <div className="text-[14px] font-medium text-slate-900 dark:text-white">
//             {title}
//           </div>
//           <div className="text-[12px] text-slate-400 dark:text-slate-500 mt-px">
//             {description}
//           </div>
//         </div>
//         <span className="ml-auto text-[11px] px-2.5 py-0.5 rounded-full bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 text-slate-400 dark:text-slate-500 whitespace-nowrap flex-shrink-0">
//           {meta}
//         </span>
//       </div>

//       {/* conditional grid container alignment */}
//       <div
//         className={
//           isCloudGrid
//             ? "p-[0.85rem] grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-2.5"
//             : "p-[0.85rem] grid grid-cols-[repeat(auto-fill,minmax(140px,1fr))] gap-2.5"
//         }
//       >
//         {children}
//       </div>
//     </div>
//   );
// }

// // ─── Main page ────────────────────────────────────────────────────────────────
// export default function AgentSetupLanding() {
//   return (
//     <div className="w-full max-w-[920px] mx-auto py-6 px-4" id="overview">
//       <h2 className="sr-only">Agent Setup Guide documentation navigation.</h2>

//       {/* Hero Header */}
//       <div className="inline-flex items-center gap-1.5 bg-orange-500/10 dark:bg-orange-500/15 border border-orange-500/25 dark:border-orange-500/30 text-orange-600 dark:text-orange-400 text-[11px] font-medium tracking-widest uppercase px-3 py-1 rounded-full mb-4">
//         <ShieldCheck className="w-3.5 h-3.5" /> Documentation
//       </div>
//       <h1 className="text-5xl font-bold tracking-tight mb-2 bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent leading-[1.15]">
//         Agent Setup Guide
//       </h1>
//       <p className="text-[15px] text-slate-500 dark:text-slate-400 leading-[1.6] mb-8 max-w-[560px]">
//         Select a setup path to open the exact documentation for your environment. Every tile routes directly to the corresponding guide.
//       </p>

//       {/* Sections List */}
//       <div>
//         {/* INFRA SECTION */}
//         <SectionCard
//           title="Infra"
//           description="OS setup guides for Linux and Windows environments."
//           icon={Server}
//           headerBg="linear-gradient(135deg,#38bdf8,#6366f1)"
//           meta="2 guides"
//         >
//           <Tile title="Linux" route="/agentlinux" subtitle="Infrastructure" gradientIndex={0} />
//           <Tile title="Windows" route="/agentwindows" subtitle="Infrastructure" gradientIndex={1} />
//         </SectionCard>

//         {/* NETWORK SECTION */}
//         <SectionCard
//           title="Network"
//           description="Connectivity and networking setup for agent communication."
//           icon={Network}
//           headerBg="linear-gradient(135deg,#a78bfa,#ec4899)"
//           meta="1 guide"
//         >
//           <Tile title="Network" route="/network" subtitle="Connectivity" gradientIndex={4} />
//         </SectionCard>

//         {/* TECHNOLOGY SECTION */}
//         <SectionCard
//           title="Technology Agent"
//           description="Language-specific setup for runtimes and frameworks."
//           icon={Cpu}
//           headerBg="linear-gradient(135deg,#f97316,#ef4444)"
//           meta="5 guides"
//         >
//           <Tile title="Java" route="/agentjava" subtitle="Runtime" gradientIndex={2} />
//           <Tile title="Python" route="/agentpython" subtitle="Runtime" gradientIndex={3} />
//           <Tile title=".Net" route="/agentdotnet" subtitle="Runtime" gradientIndex={4} />
//           <Tile title="PHP" route="/agentphp" subtitle="Runtime" gradientIndex={5} />
//           <Tile title="Node.js" route="/agentnodejs" subtitle="Runtime" gradientIndex={6} />
//         </SectionCard>

//         {/* DATABASE SECTION */}
//         <SectionCard
//           title="Database"
//           description="Database agent setup and monitoring for major engines."
//           icon={Database}
//           headerBg="linear-gradient(135deg,#f59e0b,#ef4444)"
//           meta="3 guides"
//         >
//           <Tile title="MySQL" route="/agentmysql" subtitle="Database" gradientIndex={3} />
//           <Tile title="MsSQL" route="/agentmssql" subtitle="Database" gradientIndex={0} />
//           <Tile title="Oracle" route="/agentoracle" subtitle="Database" gradientIndex={9} />
//         </SectionCard>

//         {/* MESSAGE QUEUE SECTION */}
//         <SectionCard
//           title="Message Queue"
//           description="Broker and queue integrations for event-driven systems."
//           icon={Layers}
//           headerBg="linear-gradient(135deg,#c084fc,#f472b6)"
//           meta="2 guides"
//         >
//           <Tile title="ActiveMQ" route="/activemq" subtitle="Broker" gradientIndex={4} />
//           <Tile title="Kafka" route="/agentkafka" subtitle="Broker" gradientIndex={11} />
//         </SectionCard>

//         {/* CLOUD SECTION */}
//         <SectionCard
//           title="Cloud"
//           description="Cloud-specific setup paths grouped by provider."
//           icon={Cloud}
//           headerBg="linear-gradient(135deg,#818cf8,#38bdf8)"
//           meta="4 guides"
//           isCloudGrid={true}
//         >
//           {/* Azure */}
//           <GroupCard
//             title="Azure"
//             count={1}
//             bannerBg="from-[#0078d4] to-[#50e6ff]"
//             icon={Cloud}
//             logoTitle="Azure"
//           >
//             <GroupTile
//               title="VMs"
//               route="/agentazurevm"
//               subtitle="Virtual Machines"
//               icon={Laptop}
//               iconBg="rgba(0,120,212,0.12)"
//               iconColor="#0078d4"
//             />
//           </GroupCard>

//           {/* AWS */}
//           <GroupCard
//             title="AWS"
//             count={3}
//             bannerBg="from-[#f97316] to-[#fbbf24]"
//             icon={Cloud}
//             logoTitle="AWS"
//           >
//             <GroupTile
//               title="EKS"
//               route="/agentawseks"
//               subtitle="Elastic Kubernetes"
//               icon={Box}
//               iconBg="rgba(249,115,22,0.12)"
//               iconColor="#ea580c"
//             />
//             <GroupTile
//               title="RDS"
//               route="/agentawsrds"
//               subtitle="Relational Database"
//               icon={Database}
//               iconBg="rgba(249,115,22,0.12)"
//               iconColor="#ea580c"
//             />
//             <GroupTile
//               title="Gateway"
//               route="/agentawsgateway"
//               subtitle="API Gateway"
//               icon={Globe}
//               iconBg="rgba(249,115,22,0.12)"
//               iconColor="#ea580c"
//             />
//           </GroupCard>
//         </SectionCard>
//       </div>
//     </div>
//   );
// }


import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  ShieldCheck,
  Server,
  Network,
  Cpu,
  Database,
  Layers,
  Cloud,
  Laptop,
  Box,
  Globe,
  FileText,
  ArrowRight
} from "lucide-react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";


export function renderagentsetup() {
  return <AgentSetupLanding />;
}
  
// ─── gradient configs per card ───────────────────────────────────────────────
const CARD_GRADIENTS = [
  "from-sky-400 to-indigo-500",
  "from-emerald-400 to-cyan-500",
  "from-orange-400 to-red-500",
  "from-yellow-400 to-green-500",
  "from-indigo-400 to-purple-500",
  "from-cyan-400 to-indigo-500",
  "from-emerald-400 to-teal-500",
  "from-amber-400 to-red-500",
  "from-sky-400 to-purple-500",
  "from-rose-400 to-orange-500",
  "from-purple-400 to-pink-500",
  "from-blue-700 to-sky-400",
];

function pickGradient(index) {
  return CARD_GRADIENTS[index % CARD_GRADIENTS.length];
}

const LOGO_SOURCES = {
  Linux: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/linux.svg",
  Windows: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/windows.svg",
  Network: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/cloudflare.svg",
  Java: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/java.svg",
  Python: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/python.svg",
  ".Net": "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/dotnet.svg",
  PHP: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/php.svg",
  "Node.js": "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/nodedotjs.svg",
  MySQL: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/mysql.svg",
  MsSQL: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/microsoftsqlserver.svg",
  Oracle: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/oracle.svg",
  ActiveMQ: "https://activemq.apache.org/assets/img/activemq_logo_icon.svg",
  Kafka: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/apachekafka.svg",
  Azure: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/microsoftazure.svg",
  AWS: "https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/amazonaws.svg",
};

function LogoMark({ title, className = "w-[18px] h-[18px]" }) {
  const src = LOGO_SOURCES[title];

  if (!src) return null;

  return (
    <img
      src={src}
      alt={`${title} logo`}
      className={`${className} object-contain`}
      style={{ filter: "brightness(0) invert(1)" }}
      draggable="false"
      loading="eager"
      referrerPolicy="no-referrer"
    />
  );
}

// ─── Tile card (the individual guide card with banner + avatar) ───────────────
function Tile({ title, route, subtitle, gradientIndex = 0 }) {
  const navigate = useNavigate();
  const gradient = pickGradient(gradientIndex);

  return (
    <motion.button
      onClick={() => navigate(route)}
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.97 }}
      className="group w-full text-left bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 rounded-[14px] overflow-visible relative cursor-pointer flex flex-col justify-between"
      style={{ isolation: "isolate" }}
    >
      <div>
        {/* Banner */}
        <div className="card-banner-wrap relative pb-5">
          <div className={`h-[52px] rounded-t-[14px] overflow-hidden relative bg-gradient-to-r ${gradient}`}>
            <svg className="absolute bottom-0 left-0 w-full h-6" viewBox="0 0 200 24" preserveAspectRatio="none">
              <path d="M0 12 Q50 0 100 12 Q150 24 200 12 L200 24 L0 24Z" fill="white" fillOpacity="0.13" />
            </svg>
          </div>

          {/* Logo Avatar */}
          <div
            className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-[38px] h-[38px] rounded-[11px] flex items-center justify-center text-xs font-bold text-white border-[3px] border-white dark:border-[#0e141b] shadow-[0_2px_10px_rgba(0,0,0,0.2)] z-10 bg-gradient-to-br ${gradient}`}
          >
            <LogoMark title={title} className="w-[18px] h-[18px]" />
          </div>
        </div>

        {/* Body */}
        <div className="pt-2 pb-2.5 px-3 text-center">
          <div className="text-[12px] font-medium text-slate-900 dark:text-white">
            {title}
          </div>
          <div className="text-[10px] text-slate-400 dark:text-slate-500 mt-px">
            {subtitle}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center gap-1.5 px-3 py-1.5 border-t border-slate-200/70 dark:border-white/10 text-[10px] text-slate-400 dark:text-slate-500">
        <FileText className="w-3 h-3" />
        <span>Guide</span>
        <div className="ml-auto flex items-center bg-slate-100 dark:bg-white/5 border border-slate-200/70 dark:border-white/10 rounded-full px-2 py-0.5 font-medium group-hover:bg-slate-200 dark:group-hover:bg-white/10 transition-colors">
          <ArrowRight className="w-2.5 h-2.5" />
        </div>
      </div>
    </motion.button>
  );
}

// ─── GroupCard (Azure / AWS nested tiles) ────────────────────────────────────
function GroupCard({ title, count, bannerBg, icon: Icon, logoTitle, children }) {
  return (
    <div className="rounded-[14px] bg-slate-50 dark:bg-white/5 border border-slate-200/70 dark:border-white/10 overflow-hidden">
      {/* provider banner */}
      <div className={`h-9 flex items-center gap-2 px-3.5 border-b border-slate-200/70 dark:border-white/10 bg-gradient-to-r ${bannerBg}`}>
        {logoTitle ? (
          <LogoMark title={logoTitle} className="w-4 h-4" />
        ) : (
          <Icon className="w-4 h-4 text-white" />
        )}
        <span className="text-[12px] font-semibold text-white">
          {title}
        </span>
        <span className="ml-auto text-[10px] text-white/70">
          {count} guide{count !== 1 ? "s" : ""}
        </span>
      </div>
      {/* provider body */}
      <div className="p-2 grid gap-1.5">{children}</div>
    </div>
  );
}

// ─── GroupTile (compact list row inside GroupCard) ───────────────────────────
function GroupTile({ title, route, subtitle, icon: Icon, iconBg, iconColor }) {
  const navigate = useNavigate();
  return (
    <motion.button
      onClick={() => navigate(route)}
      whileHover={{ x: 2 }}
      whileTap={{ scale: 0.98 }}
      className="group flex items-center gap-2.5 w-full text-left p-2.5 rounded-[10px] bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 transition-all"
    >
      <div
        className="w-[30px] h-[30px] rounded-[8px] flex items-center justify-center text-sm flex-shrink-0"
        style={{ backgroundColor: iconBg, color: iconColor }}
      >
        <Icon className="w-[15px] h-[15px]" />
      </div>
      <div>
        <div className="text-[12px] font-medium text-slate-900 dark:text-white">
          {title}
        </div>
        <div className="text-[10px] text-slate-400 dark:text-slate-500 mt-px">
          {subtitle}
        </div>
      </div>
      <ArrowRight className="w-3.5 h-3.5 text-slate-400 dark:text-slate-500 ml-auto transition-transform group-hover:translate-x-0.5" />
    </motion.button>
  );
}

// ─── SectionCard (the outer section wrapper) ─────────────────────────────────
function SectionCard({
  title,
  description,
  icon: Icon,
  headerBg,
  meta,
  isCloudGrid,
  children,
  ...rest // 👈 capture extra props
}) {
  return (
    <div
  {...rest}
  className="scroll-mt-24 mb-5 rounded-[20px] bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 overflow-hidden"
>
      {/* section header */}
      <div className="flex items-center gap-3 px-[1.1rem] py-[0.85rem] bg-slate-50 dark:bg-white/[0.02] border-b border-slate-200/70 dark:border-white/10">
        <div
          className="w-9 h-9 rounded-[10px] flex items-center justify-center text-lg flex-shrink-0 text-white"
          style={{ background: headerBg }}
        >
          <Icon className="w-[18px] h-[18px]" />
        </div>
        <div>
          <div className="text-[14px] font-medium text-slate-900 dark:text-white">
            {title}
          </div>
          <div className="text-[12px] text-slate-400 dark:text-slate-500 mt-px">
            {description}
          </div>
        </div>
        <span className="ml-auto text-[11px] px-2.5 py-0.5 rounded-full bg-white dark:bg-[#0e141b] border border-slate-200/70 dark:border-white/10 text-slate-400 dark:text-slate-500 whitespace-nowrap flex-shrink-0">
          {meta}
        </span>
      </div>

      <div
        className={
          isCloudGrid
            ? "p-[0.85rem] grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-2.5"
            : "p-[0.85rem] grid grid-cols-[repeat(auto-fill,minmax(140px,1fr))] gap-2.5"
        }
      >
        {children}
      </div>
    </div>
  );
}

// ─── Main page ────────────────────────────────────────────────────────────────
export default function AgentSetupLanding() {

const location = useLocation();
useEffect(() => {
  if (location.state?.scrollTo) {
    setTimeout(() => {
      const el = document.querySelector(
        `[data-section="${location.state.scrollTo}"]`
      );
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 300); // 👈 IMPORTANT
  }
}, [location]);

  return (
    <div className="w-full max-w-[920px] mx-auto py-6 px-4" id="overview">
      <h2 className="sr-only">Agent Setup Guide documentation navigation.</h2>

      {/* Hero Header */}
      <div className="inline-flex items-center gap-1.5 bg-orange-500/10 dark:bg-orange-500/15 border border-orange-500/25 dark:border-orange-500/30 text-orange-600 dark:text-orange-400 text-[11px] font-medium tracking-widest uppercase px-3 py-1 rounded-full mb-4">
        <ShieldCheck className="w-3.5 h-3.5" /> Documentation
      </div>
      <h1 className="text-5xl font-bold tracking-tight mb-2 bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent leading-[1.15]">
        Agent Setup Guide
      </h1>
      <p className="text-[15px] text-slate-500 dark:text-slate-400 leading-[1.6] mb-8 max-w-[560px]">
        Select a setup path to open the exact documentation for your environment. Every tile routes directly to the corresponding guide.
      </p>

      {/* Sections List */}
      <div>
        {/* INFRA SECTION */}
        <SectionCard data-section="Infra"
          title="Infra"
          description="OS setup guides for Linux and Windows environments."
          icon={Server}
          headerBg="linear-gradient(135deg,#38bdf8,#6366f1)"
          meta="2 guides"
        >
          <Tile title="Linux" route="/agentlinux" subtitle="Infrastructure" gradientIndex={0} />
          <Tile title="Windows" route="/agentwindows" subtitle="Infrastructure" gradientIndex={1} />
        </SectionCard>

        {/* NETWORK SECTION */}
        <SectionCard
          title="Network"
          description="Connectivity and networking setup for agent communication."
          icon={Network}
          headerBg="linear-gradient(135deg,#a78bfa,#ec4899)"
          meta="1 guide"
        >
          <Tile title="Network" route="/network" subtitle="Connectivity" gradientIndex={4} />
        </SectionCard>

        {/* TECHNOLOGY SECTION */}
        <SectionCard data-section="TechnologyAgent"
          title="Technology Agent"
          description="Language-specific setup for runtimes and frameworks."
          icon={Cpu}
          headerBg="linear-gradient(135deg,#f97316,#ef4444)"
          meta="5 guides"
        >
          <Tile title="Java" route="/agentjava" subtitle="Runtime" gradientIndex={2} />
          <Tile title="Python" route="/agentpython" subtitle="Runtime" gradientIndex={3} />
          <Tile title=".Net" route="/agentdotnet" subtitle="Runtime" gradientIndex={4} />
          <Tile title="PHP" route="/agentphp" subtitle="Runtime" gradientIndex={5} />
          <Tile title="Node.js" route="/agentnodejs" subtitle="Runtime" gradientIndex={6} />
        </SectionCard>

        {/* DATABASE SECTION */}
        <SectionCard
          title="Database"
          description="Database agent setup and monitoring for major engines."
          icon={Database}
          headerBg="linear-gradient(135deg,#f59e0b,#ef4444)"
          meta="3 guides"
        >
          <Tile title="MySQL" route="/agentmysql" subtitle="Database" gradientIndex={3} />
          <Tile title="MsSQL" route="/agentmssql" subtitle="Database" gradientIndex={0} />
          <Tile title="Oracle" route="/agentoracle" subtitle="Database" gradientIndex={9} />
        </SectionCard>

        {/* MESSAGE QUEUE SECTION */}
        <SectionCard
          title="Message Queue"
          description="Broker and queue integrations for event-driven systems."
          icon={Layers}
          headerBg="linear-gradient(135deg,#c084fc,#f472b6)"
          meta="2 guides"
        >
          <Tile title="ActiveMQ" route="/activemq" subtitle="Broker" gradientIndex={4} />
          <Tile title="Kafka" route="/agentkafka" subtitle="Broker" gradientIndex={11} />
        </SectionCard>

        {/* CLOUD SECTION */}
        <SectionCard
          title="Cloud"
          description="Cloud-specific setup paths grouped by provider."
          icon={Cloud}
          headerBg="linear-gradient(135deg,#818cf8,#38bdf8)"
          meta="4 guides"
          isCloudGrid={true}
        >
          {/* Azure */}
          <GroupCard
            title="Azure"
            count={1}
            bannerBg="from-[#0078d4] to-[#50e6ff]"
            icon={Cloud}
            logoTitle="Azure"
          >
            <GroupTile
              title="VMs"
              route="/agentazurevm"
              subtitle="Virtual Machines"
              icon={Laptop}
              iconBg="rgba(0,120,212,0.12)"
              iconColor="#0078d4"
            />
          </GroupCard>

          {/* AWS */}
          <GroupCard
            title="AWS"
            count={3}
            bannerBg="from-[#f97316] to-[#fbbf24]"
            icon={Cloud}
            logoTitle="AWS"
          >
            <GroupTile
              title="EKS"
              route="/agentawseks"
              subtitle="Elastic Kubernetes"
              icon={Box}
              iconBg="rgba(249,115,22,0.12)"
              iconColor="#ea580c"
            />
            <GroupTile
              title="RDS"
              route="/agentawsrds"
              subtitle="Relational Database"
              icon={Database}
              iconBg="rgba(249,115,22,0.12)"
              iconColor="#ea580c"
            />
            <GroupTile
              title="Gateway"
              route="/agentawsgateway"
              subtitle="API Gateway"
              icon={Globe}
              iconBg="rgba(249,115,22,0.12)"
              iconColor="#ea580c"
            />
          </GroupCard>
        </SectionCard>
      </div>
    </div>
  );
}